module.exports = __webpack_public_path__ + "img/Not Fully Closing.9d3f3b29.png";